var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-button" }, [
    _c(
      "button",
      {
        ref: "trigger",
        staticClass: "btn filter-button__button",
        on: {
          click: function ($event) {
            _vm.show = !_vm.show
          },
        },
      },
      [
        _vm._v("\n        " + _vm._s(_vm.text) + " "),
        _c("span", { staticClass: "filter-indicator" }, [
          _vm._v(" " + _vm._s(_vm.show ? "-" : "+")),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "content",
        staticClass: "filter-button__popover-content popover-content",
        class: { show: _vm.show },
        style: _vm.popoverStyles,
      },
      [
        _c(
          "div",
          { staticClass: "filter-list-container" },
          _vm._l(_vm.items, function (item) {
            return _c("filter-item", {
              key: `${_vm.name}-${item.id}`,
              attrs: {
                name: _vm.name,
                label: item.label,
                id: `${_vm.name}-${item.id}`,
                value: item.value,
              },
              on: { checked: _vm.filterHandler },
            })
          }),
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/FilterButton.vue